import { FC, ReactNode } from 'react';

import Footer from '../Footer';

import { Product } from '../../../types/tour';

import styles from './Layout.module.css';

export type Props = {
  children: ReactNode | undefined;
  product: Product.ActivityFeeds | Product.Chat | Product.Video;
};

export const Layout: FC<Props> = ({ children, product }) => (
  <div className={styles.getStartedContentLayout}>
    <div className={styles.getStartedContentContainer}>{children}</div>
    <Footer product={product} />
  </div>
);
